import jwtDecode from 'jwt-decode';
import { clearLeadsDataFromStorage } from 'Helpers/item';

export const urls = {
    getUserData: '/api/users/me',
    getUserImagesData: (userId, type) => `/api/users/${userId}/images?type=${type}`,
    requestData: userId => `/api/users/${userId}/request-data`,
    updateUser: id => `/api/users/${id}`,
    getExistingUser: id => `/api/users/${id}`,
    addFavourite: userId => `/api/v2/cupid/users/${userId}/favourites`,
    removeFavourite: (userId, itemId, categoryId, dealerType) => `/api/v2/cupid/users/${userId}/favourites/${itemId}?categoryId=${categoryId}&dealerType=${dealerType}`,
    getFavouritesIds: userId => `/api/cupid/users/${userId}/favourites/ids`,
    linkAccount: '/api/users/link-account',
    unLinkAccount: userId => `/api/users/${userId}/unlink-account`,
    createChallenge: '/api/challenges',
    validateChallenge: '/api/challenges/validate',
    postImage: '/api/images',
    authenticate: '/api/auth/authenticate',
    authenticateV3: '/api/v3/auth/authenticate',
    authenticateLogin: '/api/auth/authenticate/login',
    authenticateLoginV3: '/api/v3/auth/authenticate/login',
    deauthorize: '/api/auth/deauthorize',
    logoutAll: '/api/auth/logout-all',
    getFollowing: userId => `/api/users/${userId}/following`,
    getFollowers: userId => `/api/users/${userId}/followers`,
    getUserConsents: '/api/users/consents',
    updateUserConsents: userId => `/api/users/consents/${userId}`,
    updateCoverAndBusinessPhotos: userId => `/api/users/${userId}/images`,
    addConnection: userId => `/api/users/${userId}/connections`,
    deleteConnection: (userId, connectionId) => `/api/users/${userId}/connections/${connectionId}`
};

export const initialState = {
    sessionLong: undefined
};

export const customActions = {
    operateCounter: (userId, counter, operator) => {
        return {
            type: 'OPERATE_COUNTERS_USERS',
            data: {
                userId,
                counter,
                operator
            }
        };
    }
};

const transformLegionPostData = (url, data, stateData) => {
    const urlWithoutParams = url.split('?')[0];
    const { authToken = {}} = stateData || {};

    switch (urlWithoutParams) {
        case urls.authenticateV3:
        case urls.authenticate : {
            if (data.token) {
                const tokenDecoded = jwtDecode(data.token);

                data = {
                    auth: data,
                    authToken: {
                        ...authToken,
                        ...tokenDecoded,
                        action: tokenDecoded.grant_type
                    }
                };
            }
            return data;
        }
        case urls.authenticateLoginV3:
        case urls.authenticateLogin: {
            // clear leads data from the session storage
            clearLeadsDataFromStorage();
            if (data.accessToken) {
                const accessTokenDecoded = jwtDecode(data.accessToken);
                const refreshTokenDecoded = jwtDecode(data.refreshToken);

                data = {
                    auth: {
                        status: data.status,
                        pin_token: data.pin_token,
                        reactivated: refreshTokenDecoded.reactivated
                    },
                    authToken: {
                        ...authToken,
                        ...accessTokenDecoded,
                        grant_type: accessTokenDecoded.grantType,
                        is_new_user: accessTokenDecoded.isNewUser
                    },
                    user: data.user
                };
            }
            return data;
        }
    }

    return data;
};

const transformAutoLoginPostData = (url, data, stateData) => {
    const urlWithoutParams = url.split('?')[0];
    const { authToken = {}} = stateData || {};

    switch (urlWithoutParams) {
        case urls.authenticate: {
            if (data.accessToken) {
                const accessTokenDecoded = jwtDecode(data.accessToken);
                const refreshTokenDecoded = jwtDecode(data.refreshToken);

                data = {
                    auth: {
                        status: data.status,
                        pin_token: data.pin_token,
                        reactivated: refreshTokenDecoded.reactivated
                    },
                    authToken: {
                        ...authToken,
                        ...accessTokenDecoded,
                        grant_type: accessTokenDecoded.grantType,
                        is_new_user: accessTokenDecoded.isNewUser
                    },
                    user: data.user
                };
            }
            return data;
        }
    }

    return data;
};

export const operateFavouriteItem = (item, operator) => (
    {
        type: `${operator}_FAVOURITE`,
        item
    }
);

const removeFavourite = (favourites = [], itemId) => {
    itemId = parseInt(itemId, 10);
    return favourites.filter(item => item?.adId !== itemId);
};
const arrayObjectUnion = (arr1 = [], arr2 = []) => {
    const mergedArray = [...arr1, ...arr2];

    const set = new Set();
    const unionArray = mergedArray.filter(item => {
        if (item && !set.has(item.adId)) {
            set.add(item.adId);
            return true;
        }
        return false;
    }, set);

    return unionArray;
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'REQUEST_FAVOURITES':
            return {
                ...state,
                isFetching: true,
                isFetched: false
            };
        case 'RECEIVE_FAVOURITES':
        {
            return {
                ...state,
                favouritesItems: arrayObjectUnion(state.favouritesItems, action.data.data),
                isFetching: false,
                isFetched: true
            };
        }
        case 'ERROR_FAVOURITES':
            return {
                isFetching: false,
                isFetched: true
            };
        case 'LOGOUT':
            return {
                ...state,
                favouritesItems: null,
                tokenInfo: null,
                loggedOut: true,
                isFetched: false
            };
        case 'ADD_FAVOURITE':
            return {
                ...state,
                favouritesItems: [...state.favouritesItems, action.item]
            };
        case 'REMOVE_FAVOURITE':
            return {
                ...state,
                favouritesItems: removeFavourite(state.favouritesItems, action.item)
            };
        case 'UPDATE_SESSION_LONG':
            return {
                ...state,
                sessionLong: action.data
            };
        case 'RESPONSE_POST_USER': {
            const userData = transformLegionPostData(action.url, action.data, state.userData);

            return {
                ...state,
                userData,
                tokenInfo: {
                    expire: userData.authToken.exp * 1000 // eslint-disable-line no-magic-numbers
                },
                favouritesItems: []
            };
        }
        case 'RESPONSE_POST_AUTOLOGIN': {
            const userData = transformAutoLoginPostData(action.url, action.data, state.userData);

            return {
                ...state,
                userData,
                tokenInfo: {
                    expire: userData.authToken.exp * 1000 // eslint-disable-line no-magic-numbers
                },
                favouritesItems: []
            };
        }
        case 'CLEAN_AUTH_DATA': {
            return {
                ...state,
                userData: null
            };
        }
        case 'SET_TOKEN_EXPIRE': {
            return {
                ...state,
                tokenInfo: {
                    ...state.tokenInfo,
                    expire: action.expire
                }
            };
        }
        case 'SET_REFRESH_TOKEN_STATE': {
            return {
                ...state,
                tokenInfo: {
                    ...state.tokenInfo,
                    ...action.data
                }
            };
        }
        case 'SET_CLASSIC_TOKEN': {
            return {
                ...state,
                sessionMigration: {
                    ...state.sessionMigration,
                    ...action.data
                }
            };
        }
        case 'CLEAN_CLASSIC_TOKEN': {
            return {
                ...state,
                sessionMigration: null
            };
        }
        default:
            return state;
    }
};
